var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowUpRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9103 3.4105C16.2358 3.08523 16.7633 3.08512 17.0887 3.4105C17.4139 3.7359 17.4139 4.26349 17.0887 4.58889L5.0884 16.5892C4.763 16.9144 4.23541 16.9144 3.91001 16.5892C3.58463 16.2638 3.58474 15.7363 3.91001 15.4108L15.9103 3.4105Z",
    fill: "#F5A425"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6663 11.0002V4.83317H9.49935C9.03911 4.83317 8.66602 4.46007 8.66602 3.99984C8.66602 3.5396 9.03911 3.1665 9.49935 3.1665H16.4997C16.9598 3.16668 17.333 3.53971 17.333 3.99984V11.0002C17.3328 11.4601 16.9597 11.8333 16.4997 11.8335C16.0395 11.8335 15.6665 11.4602 15.6663 11.0002Z",
    fill: "#F5A425"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUpRight1);
export default __webpack_public_path__ + "static/media/ic-arrow-up-right-1.2194e3eb4ff166b5dbd9f2fea2b87383.svg";
export { ForwardRef as ReactComponent };